import { SHOPIFY_STOREFRONT_GRAPHQL_API, SHOPIFY_STOREFRONT_TOKEN } from "../config";
import { GET_CART_LINES } from "../graphqlQueries";
import { TCartInfo } from "../types";

const getCartData = async (productRenderedLocation: string, headlessCartInfo: TCartInfo) => {
  if (productRenderedLocation === "external") {
    const graphqlEndpoint = SHOPIFY_STOREFRONT_GRAPHQL_API;
    const authToken = SHOPIFY_STOREFRONT_TOKEN;

    const headers = {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": authToken,
    };

    const requestOptions = {
      method: "POST",
      headers,
      body: JSON.stringify({
        query: GET_CART_LINES,
        variables: {
          id: headlessCartInfo.id,
        },
      }),
    };

    try {
      const response = await fetch(graphqlEndpoint, requestOptions);
      const responseData = await response.json();
      const cartData = responseData?.data;

      if (cartData) {
        const cartData = responseData?.data?.cart;
        if (cartData) {
          return {
            cart: cartData,
          };
        } else {
          console.error("Cart data is missing in the GraphQL response.", responseData);
        }
      } else {
        console.error("GraphQL error:", responseData?.errors);
      }
    } catch (error) {
      console.error("GraphQL request failed:", error);
    }
  } else {
    try {
      const response = await fetch("/cart.json");
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();

      return {
        cart: data,
      };
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
    }

    // listen for this custom event
    window.addEventListener("cart:updated", (event: CustomEventInit) => {
      const data = event.detail;
      console.log("cart:updated - getCartData - data ===> ", data);
      if (data?.items?.length === 0) {
        return {
          isCartEmpty: true,
        };
      }
    });
  }
};

export default getCartData;
